import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import InputField from '../components/ui/InputField';
import TextAreaField from '../components/ui/TextAreaField';
import Button from '../components/ui/Button';

const NakliyeReportForm = ({ onDataChange }) => {
  const { t } = useTranslation();
  const [tripInfo, setTripInfo] = useState({
    companyName: '',
    vehicleNumber: '',
    driverName: '',
    route: '',
    tripDate: new Date().toISOString().split('T')[0]
  });

  const [income, setIncome] = useState([
    { description: '', amount: 0 }
  ]);

  const [expenses, setExpenses] = useState([
    { expenseItem: '', amount: 0 }
  ]);

  const [notes, setNotes] = useState('');

  useEffect(() => {
    const totalIncome = income.reduce((sum, item) => sum + item.amount, 0);
    const totalExpense = expenses.reduce((sum, item) => sum + item.amount, 0);
    const tripProfit = totalIncome - totalExpense;

    onDataChange({
      ...tripInfo,
      income,
      expenses,
      notes,
      totalIncome,
      totalExpense,
      tripProfit,
      date: new Date().toLocaleDateString()
    });
  }, [tripInfo, income, expenses, notes, onDataChange]);

  const totalIncome = income.reduce((sum, item) => sum + item.amount, 0);
  const totalExpense = expenses.reduce((sum, item) => sum + item.amount, 0);
  const tripProfit = totalIncome - totalExpense;

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl p-6 lg:p-8 border border-gray-200 dark:border-gray-700 shadow-sm space-y-8">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <InputField label="Company Name" name="companyName" value={tripInfo.companyName} onChange={(e) => setTripInfo({ ...tripInfo, companyName: e.target.value })} placeholder="Transport company" required />
        <InputField label="Vehicle Number" name="vehicleNumber" value={tripInfo.vehicleNumber} onChange={(e) => setTripInfo({ ...tripInfo, vehicleNumber: e.target.value })} placeholder="e.g., ABC-123" />
        <InputField label="Driver Name" name="driverName" value={tripInfo.driverName} onChange={(e) => setTripInfo({ ...tripInfo, driverName: e.target.value })} placeholder="Driver name" />
        <InputField label="Route" name="route" value={tripInfo.route} onChange={(e) => setTripInfo({ ...tripInfo, route: e.target.value })} placeholder="e.g., Nairobi - Mombasa" />
        <InputField label="Trip Date" name="tripDate" type="date" value={tripInfo.tripDate} onChange={(e) => setTripInfo({ ...tripInfo, tripDate: e.target.value })} />
      </div>

      <div>
        <h3 className="text-xl font-bold text-[#111418] dark:text-white mb-4">Income</h3>
        <div className="overflow-x-auto">
          <table className="w-full text-left">
            <thead className="border-b border-gray-200 dark:border-gray-700">
              <tr>
                <th className="p-3 text-sm font-medium text-gray-600 dark:text-gray-400">Description</th>
                <th className="p-3 text-sm font-medium text-gray-600 dark:text-gray-400 text-right">Amount</th>
                <th className="p-3 w-12"></th>
              </tr>
            </thead>
            <tbody>
              {income.map((item, index) => (
                <tr key={index} className="border-b border-gray-200 dark:border-gray-700">
                  <td className="p-2">
                    <input className="form-input w-full bg-transparent border-0 focus:ring-0 p-2" type="text" value={item.description} onChange={(e) => { const newIncome = [...income]; newIncome[index].description = e.target.value; setIncome(newIncome); }} placeholder="e.g., Freight charge" />
                  </td>
                  <td className="p-2">
                    <input className="form-input w-full bg-transparent border-0 focus:ring-0 p-2 text-right" type="number" min="0" step="0.01" value={item.amount} onChange={(e) => { const newIncome = [...income]; newIncome[index].amount = parseFloat(e.target.value) || 0; setIncome(newIncome); }} />
                  </td>
                  <td className="p-2 text-center">
                    <button onClick={() => setIncome(income.filter((_, i) => i !== index))} className="text-gray-400 hover:text-red-500" disabled={income.length === 1}>
                      <span className="material-symbols-outlined text-xl">delete</span>
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <Button onClick={() => setIncome([...income, { description: '', amount: 0 }])} variant="ghost" icon="add_circle" className="mt-4">Add Income</Button>
        </div>
      </div>

      <div>
        <h3 className="text-xl font-bold text-[#111418] dark:text-white mb-4">Expenses</h3>
        <div className="overflow-x-auto">
          <table className="w-full text-left">
            <thead className="border-b border-gray-200 dark:border-gray-700">
              <tr>
                <th className="p-3 text-sm font-medium text-gray-600 dark:text-gray-400">Expense Item</th>
                <th className="p-3 text-sm font-medium text-gray-600 dark:text-gray-400 text-right">Amount</th>
                <th className="p-3 w-12"></th>
              </tr>
            </thead>
            <tbody>
              {expenses.map((expense, index) => (
                <tr key={index} className="border-b border-gray-200 dark:border-gray-700">
                  <td className="p-2">
                    <input className="form-input w-full bg-transparent border-0 focus:ring-0 p-2" type="text" value={expense.expenseItem} onChange={(e) => { const newExpenses = [...expenses]; newExpenses[index].expenseItem = e.target.value; setExpenses(newExpenses); }} placeholder="e.g., Fuel, Toll fees" />
                  </td>
                  <td className="p-2">
                    <input className="form-input w-full bg-transparent border-0 focus:ring-0 p-2 text-right" type="number" min="0" step="0.01" value={expense.amount} onChange={(e) => { const newExpenses = [...expenses]; newExpenses[index].amount = parseFloat(e.target.value) || 0; setExpenses(newExpenses); }} />
                  </td>
                  <td className="p-2 text-center">
                    <button onClick={() => setExpenses(expenses.filter((_, i) => i !== index))} className="text-gray-400 hover:text-red-500" disabled={expenses.length === 1}>
                      <span className="material-symbols-outlined text-xl">delete</span>
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <Button onClick={() => setExpenses([...expenses, { expenseItem: '', amount: 0 }])} variant="ghost" icon="add_circle" className="mt-4">Add Expense</Button>
        </div>
      </div>

      <div className="flex justify-end">
        <div className="w-full max-w-sm space-y-3 bg-gray-50 dark:bg-gray-900 p-4 rounded-lg">
          <div className="flex justify-between items-center">
            <span className="text-gray-600 dark:text-gray-400">Total Income</span>
            <span className="font-medium text-green-600 dark:text-green-400">${totalIncome.toFixed(2)}</span>
          </div>
          <div className="flex justify-between items-center">
            <span className="text-gray-600 dark:text-gray-400">Total Expense</span>
            <span className="font-medium text-red-600 dark:text-red-400">${totalExpense.toFixed(2)}</span>
          </div>
          <div className="flex justify-between items-center pt-3 border-t border-gray-200 dark:border-gray-700">
            <span className="text-lg font-bold text-[#111418] dark:text-gray-100">Trip Profit</span>
            <span className={`text-lg font-bold ${tripProfit >= 0 ? 'text-green-600' : 'text-red-600'}`}>${tripProfit.toFixed(2)}</span>
          </div>
        </div>
      </div>

      <TextAreaField label={t('form.notes')} value={notes} onChange={(e) => setNotes(e.target.value)} placeholder="Trip notes, delays, issues..." rows={3} />
    </div>
  );
};

export default NakliyeReportForm;
